<span fxLayout="row" fxLayoutGap="20px" class="res-pad-lr-0-20 results-title w-100" fxLayoutAlign="space-between">

  <h1 *ngIf="searchParams.src && searchParams.src.includes('kino')" class="primary-color mat-headline-1 mb-0 mt-0 desktop-only">
    Aktuell im Kino: {{ rowCount > 10 ? rowCount : '' }}
    {{ 'searchList.searchresults' | translate }}
  </h1>

  <h1 *ngIf="searchParams.src && searchParams.src.includes('kino')" class="primary-color mat-headline-1 mb-0 mt-0 mobile-only">
    Aktuell im Kino: {{ rowCount > 4 ? rowCount : '' }}
    {{ 'searchList.searchresults' | translate }}
  </h1>

  <span *ngIf="!searchParams.src || !searchParams.src.includes('kino')" class="primary-color mat-headline-1 mb-0 mt-0 desktop-only">
    <span *ngIf="rowCount > 10">
      {{ rowCount }}
    </span>
    {{ 'searchList.searchresults' | translate }}
  </span>

  <span *ngIf="!searchParams.src || !searchParams.src.includes('kino')" class="primary-color mat-headline-1 mb-0 mt-0 mobile-only">
    <span *ngIf="rowCount > 4">
      {{ rowCount }}
    </span>
    {{ 'searchList.searchresults' | translate }}
  </span>

  <mat-checkbox class="cb" *ngIf="currentShowsFilterVisible" disableRipple color="primary"
    [checked]="currentShowsChecked" (change)="filterCurrentShows($event)">
    {{ 'searchList.currentShows' | translate }}
  </mat-checkbox>
</span>
